export default "__VITE_ASSET__BvVNJ3Oo__"